// extracted by mini-css-extract-plugin
export default {"loadingMask":"PageLoader_loadingMask__uvwYn","circularProgress":"PageLoader_circularProgress__Tid5G"};